/* eslint-disable import/prefer-default-export */
export enum CampaignSubmissionPhase {
  Loading = 'LOADING',
  Initial = 'INITIAL',
  Success = 'SUCCESS',
  Duplicate = 'DUPLICATE',
  Error = 'ERROR',
  Ineligible = 'INELIGIBLE',
  InvalidLink = 'INVALID_LINK',
  Expired = 'EXPIRED',
}
